













import {
    defineComponent,
    onMounted,
    provide,
    reactive,
    toRefs,
} from '@vue/composition-api'
import axios from 'axios'

// Components
import FormWrap from '@/component/form/Wrap.vue'

// Store
import makeFormStore, { StoreKey as FormStoreKey } from '@/store/Form'
import makeInputStore, { StoreKey as InputStoreKey } from '@/store/Input'
import makeErrorStore, { StoreKey as ErrorStoreKey } from '@/store/Error'
import makeValidatedStore, { StoreKey as ValidatedKey } from '@/store/Validated'

const getComponentState = () => {
    const state = reactive({
        isLoaded: false,
    })

    return toRefs(state)
}

export default defineComponent({
    props: {
        formId: { type: Number, required: true },
        basePath: { type: String, required: true },
    },
    components: {
        FormWrap,
    },
    setup(props) {
        const formStore = makeFormStore()
        provide(FormStoreKey, formStore)

        const store = makeInputStore(props.formId)
        provide(InputStoreKey, store)

        const errorStore = makeErrorStore()
        provide(ErrorStoreKey, errorStore)

        const validatedStore = makeValidatedStore()
        provide(ValidatedKey, validatedStore)

        const state = getComponentState()

        onMounted(async () => {
            formStore.base_path = props.basePath

            const response = await axios
                .get(`${formStore.base_path}/api/form/${props.formId}`)
                .catch((e) => {
                    console.log(e)
                })

            if (!response || typeof response.data !== 'object') {
                throw Error('Failed to post')
            }

            if (response.data.error) {
                return
            }

            formStore.update(response.data.data)
            store.update(response.data.data.old, formStore)

            if (store.howto) {
                store.selectedHowto =
                    formStore.howto.find((el) => el.label === store.howto) ||
                    null
            }
            if (store.shop) {
                store.selectedShop =
                    formStore.shops.find((el) => el.label === store.shop) ||
                    null
            }

            state.isLoaded.value = true
        })

        return { ...state }
    },
})
